<template>
  <main class="main px-5" :class="{ 'expand-main': isMenuCollapse }">
    <h4>AI Meetings Replay</h4>
    <section>
      <div v-if="loading || loadingTotal">
        <LoadingSpinner />
      </div>
      <div :class="clientWithAIAnalyses != 0 ? 'card p-2' : ''" v-else>
        <!-- paginacion y totales -->
        <div v-if="clientWithAIAnalyses != 0" class="col-md-12 w-100 my-2">
          <div class="row my-2">
            <div>
              <span class="mr-1">{{ $t("lang.label.results") }}:</span>
              <small v-if="total < 0" class="ml-1 text-primary mr-4">{{ $t("lang.search.calculating") }}...</small>
              <strong class="mr-5" v-else>{{ total }}</strong>
            </div>
            <div class="col-md-12 d-flex align-items-center justify-content-center">
              <Pagination
                :total="total"
                :totalpage="totalPage"
                :model="pagination"
                :limit="false"
                :color="'primary'"
                @changePage="getData"
                key="paginationkey"
              />
            </div>
          </div>
        </div>

        <div v-if="clientWithAIAnalyses != 0" class="table-responsive mx-0 px-0">
          <table class="table table-hover bg-white w-100 ai-meetings-table">
            <thead>
              <tr>
                <th class="border-top-0">Meeting Name</th>
                <th v-if="user.role_id == 1" class="border-top-0">Client</th>
                <th class="border-top-0">Opportunity</th>
                <th class="border-top-0">User</th>
                <th class="border-top-0">Duration</th>
                <th class="border-top-0">Prospect Company</th>
                <th class="border-top-0">Prospect Name</th>
                <th class="border-top-0 text-center" style="min-width:130px">Overall score</th>
                <th class="border-top-0" style="min-width:160px">Opening &amp; Framing</th>
                <th class="border-top-0" style="min-width:160px">Pain Point</th>
                <th class="border-top-0" style="min-width:160px">Pitch &amp; Demo</th>
                <th class="border-top-0" style="min-width:160px">Next Step</th>
                <th class="border-top-0">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in list" :key="idx">
                <!-- Meeting Name -->
                <td style="min-width:200px">
                  <!-- <a href="#" class="text-primary d-block" @click.prevent="goToMeeting(item)">
                    {{ item.meeting_name || item.opportunity }}
                  </a> -->
                  <small>
                    {{ item.business_contact_name }} x {{ item.user_name }}
                  </small>
                  <br>
                  <small class="text-muted">{{ formatDate(item.date_meeting) }}</small>
                  <br>
                  <span class="badge" :class="recordingStatusClass(item.recording_status)" style="font-size:10px">
                    {{ recordingStatusLabelFr(item.recording_status) }}
                  </span>
                </td>

                <!-- Client -->
                <td v-if="user.role_id == 1" >
                  <a href="#" class="text-primary" @click.prevent="goToClient(item.client_id)">
                    {{ item.client_name }}
                  </a>
                </td>

                <!-- Opportunity -->
                <td>
                  <a href="#" class="text-primary" @click.prevent="goToOpportunity(item.link_id)">
                    {{ item.business_name || item.opportunity }}
                  </a>
                </td>

                <!-- Owner -->
                <td>{{ item.user_name }}</td>

                <!-- Duration -->
                <td>{{ item.meeting_duration || '—' }}</td>

                <!-- Prospect Company -->
                <td>{{ item.business_name || '—' }}</td>

                <!-- Prospect Name -->
                <td>{{ item.business_contact_name || '—' }}</td>

                <!-- Overall Score -->
                <td class="text-center">
                  <template v-if="getCoaching(item)">
                    <span class="score-dot" :class="overallScoreDotClass(getCoaching(item))"></span>
                    <strong>{{ overallScore(getCoaching(item)) }}</strong>
                    <span class="text-muted">/20</span>
                  </template>
                  <template v-else-if="item.coaching_status === 'in_progress'">
                    <small class="text-muted"><i class="icon-spinner2 spin"></i> Scoring in progress...</small>
                  </template>
                  <template v-else>
                    <span class="text-muted">—</span>
                  </template>
                </td>

                <!-- Opening & Framing -->
                <td>
                  <template v-if="getCoaching(item) && getCoaching(item).opening_framing">
                    <div class="score-bar-wrap"
                      @mouseenter="showTooltip($event, 'Opening & Framing — ' + getCoaching(item).opening_framing.score + '/5', getCoaching(item).opening_framing.description)"
                      @mouseleave="hideTooltip">
                      <div class="d-flex align-items-center score-bar-row">
                        <small class="mr-1 score-label">{{ getCoaching(item).opening_framing.score }}/5</small>
                        <div class="score-bar-bg flex-grow-1">
                          <div class="score-bar-fill" :style="{ width: (getCoaching(item).opening_framing.score / 5 * 100) + '%' }"></div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <span v-else class="text-muted">—</span>
                </td>

                <!-- Pain Point -->
                <td>
                  <template v-if="getCoaching(item) && getCoaching(item).pain_point">
                    <div class="score-bar-wrap"
                      @mouseenter="showTooltip($event, 'Pain point — ' + getCoaching(item).pain_point.score + '/5', getCoaching(item).pain_point.description)"
                      @mouseleave="hideTooltip">
                      <div class="d-flex align-items-center score-bar-row">
                        <small class="mr-1 score-label">{{ getCoaching(item).pain_point.score }}/5</small>
                        <div class="score-bar-bg flex-grow-1">
                          <div class="score-bar-fill" :style="{ width: (getCoaching(item).pain_point.score / 5 * 100) + '%' }"></div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <span v-else class="text-muted">—</span>
                </td>

                <!-- Pitch & Demo -->
                <td>
                  <template v-if="getCoaching(item) && getCoaching(item).pitch_demo">
                    <div class="score-bar-wrap"
                      @mouseenter="showTooltip($event, 'Pitch & Demo — ' + getCoaching(item).pitch_demo.score + '/5', getCoaching(item).pitch_demo.description)"
                      @mouseleave="hideTooltip">
                      <div class="d-flex align-items-center score-bar-row">
                        <small class="mr-1 score-label">{{ getCoaching(item).pitch_demo.score }}/5</small>
                        <div class="score-bar-bg flex-grow-1">
                          <div class="score-bar-fill" :style="{ width: (getCoaching(item).pitch_demo.score / 5 * 100) + '%' }"></div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <span v-else class="text-muted">—</span>
                </td>

                <!-- Next Step -->
                <td>
                  <template v-if="getCoaching(item) && getCoaching(item).next_step">
                    <div class="score-bar-wrap"
                      @mouseenter="showTooltip($event, 'Next step — ' + getCoaching(item).next_step.score + '/5', getCoaching(item).next_step.description)"
                      @mouseleave="hideTooltip">
                      <div class="d-flex align-items-center score-bar-row">
                        <small class="mr-1 score-label">{{ getCoaching(item).next_step.score }}/5</small>
                        <div class="score-bar-bg flex-grow-1">
                          <div class="score-bar-fill" :style="{ width: (getCoaching(item).next_step.score / 5 * 100) + '%' }"></div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <span v-else class="text-muted">—</span>
                </td>

                <!-- Actions -->
                <td>
                  <button class="btn btn-primary btn-sm" @click="openMeetingAnalysisModal({ meetingId: item.meeting_recording_id, opportunity_id: item.link_id })" :disabled="!item.meeting_recording_id">
                    View Analysis
                  </button>
                </td>
              </tr>

              <tr v-if="list.length === 0">
                <td colspan="12" class="text-center text-muted py-4">No meetings found.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="row mx-0 w-100" v-else>
          <contactWithYourAM :clientId="user.client_id" />
        </div>

        <modal
          :resizable="true"
          :scrollable="true"
          :max-width="980"
          height="auto"
          width="85%"
          style="z-index: 10"
          class="modal-preview p-4"
          name="meetingAnalysisModal"
          @opened="onMeetingAnalysisModalOpened"
        >
          <MeetingRecordings
            ref="meetingRecordings"
            :opportunity-id="link_id"
            :opportunity="opportunity || {}"
            :fromMeetingReplay="true"
            :infoForReplay="recordingInfo"
            @records-updated="onMeetingRecordsUpdated"
          />
        </modal>
      </div>
    </section>

    <!-- Score tooltip portal (position:fixed, nunca cortado por viewport) -->
    <div v-if="activeTooltip" class="score-tooltip-portal" :style="tooltipStyle">
      <div class="score-tip-title">{{ activeTooltip.title }}</div>
      <div class="score-tip-desc">{{ activeTooltip.desc }}</div>
    </div>
  </main>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Pagination from "@/components/Common/Pagination.vue";
import contactWithYourAM from "@/views/ContactWithYourAM.vue";
import MeetingRecordings from "@/components/Opportunities/MeetingRecordings.vue";
import { clientsService } from "@/_services";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      loading: false,
      clientWithAIAnalyses: 1,
      recordingInfo: {
        business_name: "",
        sales_rep: "",
        website: "",
      },
      list: [],
      requestedMeetingId: null,
      link_id: null,
      meetingAnalysisRecords: [],
      meetingRecordingsLoadedForLinkId: null,
      pagination: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      loadingTotal: false,
      total: 0,
      activeTooltip: null,
      tooltipStyle: {},
    };
  },
  computed: {
    ...mapState({
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
    }),
    user() {
      return this.$store.state.authentication.user;
    },
    totalPage() {
      return this.list.length;
    },
  },
  components: {
    LoadingSpinner,
    contactWithYourAM,
    Pagination,
    MeetingRecordings,
  },
  created() {
    if (this.user.role_id != 1) {
      this.clientWithAIAnalyses = this.user.ai_meeting_analisis;
      if (this.clientWithAIAnalyses == 0) {
        return;
      }
    } else {
      this.clientWithAIAnalyses = 1;
    }
    this.getTotalData();
    this.getData();
  },
  mounted() {
    this.setHeader();
  },
  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    setHeader() {
      this.setCurrentRoute({
        page: "ai-meetings-replay",
        label: "AI Meetings Replay",
      });
      this.setCurrentRouteChild({ child: "" });
    },
    openMeetingAnalysisModal(payload = {}) {
      this.list.forEach((item) => {
        if(Number(item.link_id) === Number(payload.opportunity_id)) {
          this.recordingInfo.business_name = item.business_name || "";
          this.recordingInfo.sales_rep = item.user_name || "";
          this.recordingInfo.website = item.business_domain || "";
        }
      });
      this.link_id = payload.opportunity_id;
      this.preloadMeetingRecordingsForBox(payload.opportunity_id);
      this.requestedMeetingId = payload && payload.meetingId ? Number(payload.meetingId) : null;
      this.$modal.show("meetingAnalysisModal");
    },
    onMeetingAnalysisModalOpened() {
      if (this.$refs.meetingRecordings) {
        this.$refs.meetingRecordings.load({ meetingId: this.requestedMeetingId });
      }
    },
    onMeetingRecordsUpdated({ records, loadedForLinkId }) {
      this.meetingAnalysisRecords = records;
      this.meetingRecordingsLoadedForLinkId = loadedForLinkId;
    },
    async preloadMeetingRecordingsForBox(opportunityId) {
      if (!this.link_id) return;
      if (Number(this.meetingRecordingsLoadedForLinkId) === Number(this.link_id)) return;
      try {
        const result = await opportunitiesService.getMeetingRecordingsAnalysis(opportunityId);
        const records = Array.isArray(result) ? result : [];
        this.meetingAnalysisRecords = records.map((row) => ({
          ...row,
          meeting_recording_id: row.meeting_recording_id != null ? Number(row.meeting_recording_id) : null,
          meetingDisplayLabel: row.meetingDisplayLabel || (() => {
            const value = row.start_time || row.event_date || row.recording_created_at;
            const dateStr = value ? new Date(value).toLocaleString() : "Meeting";
            const ownerName = [row.owner_first_name, row.owner_last_name].filter(Boolean).join(" ").trim();
            const ownerEmail = row.owner_email || "";
            const ownerLabel = ownerName && ownerEmail ? `${ownerName} (${ownerEmail})` : ownerName || ownerEmail || "Sin usuario";
            return `${dateStr} ${ownerLabel}`;
          })(),
        }));
        this.meetingRecordingsLoadedForLinkId = this.link_id;
      } catch (e) {
        // Silent fail — la caja simplemente no se muestra
      }
    },
    getTotalData() {
      let currentPage = this.pagination.currentPage;
      let cantPerPage = this.pagination.cantPerPage;
      let getTotal = 1;
      this.loadingTotal = true;
      clientsService
        .getAIMeetingsReplay(currentPage, cantPerPage, getTotal)
        .then((response) => {
          this.total = response.result.total;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loadingTotal = false;
        });
    },
    getData() {
      let currentPage = this.pagination.currentPage;
      let cantPerPage = this.pagination.cantPerPage;
      let getTotal = 0;
      this.loading = true;
      clientsService
        .getAIMeetingsReplay(currentPage, cantPerPage, getTotal)
        .then((response) => {
          this.list = (response.result.list || []).map((item) => {
            let coaching = null;
            if (item.coaching_result) {
              try {
                let raw = item.coaching_result;
                // Strip HTML line breaks if any
                raw = raw.replace(/<br\s*\/?>/gi, ' ');
                coaching = JSON.parse(raw);
              } catch (e) {
                coaching = null;
              }
            }
            return { ...item, _coaching: coaching };
          });
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCoaching(item) {
      return item._coaching || null;
    },
    overallScore(coaching) {
      if (!coaching) return null;
      const opening = (coaching.opening_framing && coaching.opening_framing.score) ? Number(coaching.opening_framing.score) : 0;
      const pain = (coaching.pain_point && coaching.pain_point.score) ? Number(coaching.pain_point.score) : 0;
      const pitch = (coaching.pitch_demo && coaching.pitch_demo.score) ? Number(coaching.pitch_demo.score) : 0;
      const next = (coaching.next_step && coaching.next_step.score) ? Number(coaching.next_step.score) : 0;
      return opening + pain + pitch + next;
    },
    overallScoreDotClass(coaching) {
      const score = this.overallScore(coaching);
      if (score === null) return '';
      if (score >= 16) return 'dot-green';
      if (score >= 10) return 'dot-orange';
      return 'dot-red';
    },
    recordingStatusClass(status) {
      if (!status) return 'badge-secondary';
      const s = status.toLowerCase().replace(/_/g, ' ');
      if (s === 'done' || s === 'completed') return 'badge-success';
      if (s === 'scheduled') return 'badge-warning';
      if (s === 'in progress' || s === 'in_progress' || s === 'processing') return 'badge-warning';
      if (s === 'none joined' || s === 'not-accepted' || s === 'not accepted' || s === 'failed' || s === 'error' || s === 'bot_removed' || s === 'bot removed') return 'badge-danger';
      return 'badge-secondary';
    },
    /** Libellés FR pour l’affichage uniquement (les classes de badge restent inchangées). */
    recordingStatusLabelFr(status) {
      if (status == null || String(status).trim() === '') return 'Inconnu';
      const s = String(status)
        .toLowerCase()
        .trim()
        .replace(/[-_]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      const labels = {
        done: 'Compte-rendu disponible',
        completed: 'Compte-rendu disponible',
        scheduled: 'Planifié',
        'none joined': 'Aucun participant',
        'not accepted': 'Accès refusé',
        'bot removed': 'Retiré de la visio',
        'in progress': 'Traitement en cours',
        processing: 'Traitement en cours',
        failed: 'Échec du traitement',
        error: 'Erreur technique',
      };
      if (labels[s]) return labels[s];
      return 'En attente de mise à jour';
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return dateStr;
      return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    },
    goToMeeting(item) {
      if (item.link_id) {
        window.open('/opportunities/' + item.link_id, '_blank');
      }
    },
    goToClient(client_id) {
      window.open('/clients/' + client_id, '_blank');
    },
    goToOpportunity(link_id) {
      window.open('/opportunities/' + link_id, '_blank');
    },
    showTooltip(event, title, desc) {
      const rect = event.currentTarget.getBoundingClientRect();
      const tooltipWidth = 320;
      const estimatedHeight = 130;
      const margin = 8;

      let left = rect.left;
      if (left + tooltipWidth > window.innerWidth - 10) {
        left = window.innerWidth - tooltipWidth - 10;
      }
      if (left < 10) left = 10;

      const spaceBelow = window.innerHeight - rect.bottom;
      let top, bottom;
      if (spaceBelow >= estimatedHeight + margin) {
        top = (rect.bottom + margin) + 'px';
        bottom = 'auto';
      } else {
        top = 'auto';
        bottom = (window.innerHeight - rect.top + margin) + 'px';
      }

      this.activeTooltip = { title, desc };
      this.tooltipStyle = {
        position: 'fixed',
        left: left + 'px',
        top,
        bottom,
        zIndex: 99999,
        width: tooltipWidth + 'px',
      };
    },
    hideTooltip() {
      this.activeTooltip = null;
    },
  },
};
</script>

<style scoped>
.ai-meetings-table th {
  font-size: 12px;
  color: #6c757d;
  font-weight: 600;
  white-space: nowrap;
}
.ai-meetings-table td {
  vertical-align: middle;
  font-size: 13px;
}

/* Score bar */
.score-bar-row {
  cursor: default;
}
.score-label {
  min-width: 28px;
  color: #555;
  font-size: 12px;
}
.score-bar-bg {
  height: 6px;
  background: #e0e0e0;
  border-radius: 3px;
  overflow: hidden;
  min-width: 60px;
}
.score-bar-fill {
  height: 100%;
  background: #2563eb;
  border-radius: 3px;
  transition: width 0.3s;
}

/* Overall score dot */
.score-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  vertical-align: middle;
}
.dot-green  { background: #22c55e; }
.dot-orange { background: #f59e0b; }
.dot-red    { background: #ef4444; }

/* spinner */
.spin {
  animation: spin 1s linear infinite;
}
@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

/* Score bar wrapper */
.score-bar-wrap {
  cursor: default;
  width: 100%;
}
</style>

<style>
/* Portal tooltip (position:fixed via JS) */
.score-tooltip-portal {
  background: #1e2330;
  color: #fff;
  border-radius: 6px;
  padding: 10px 14px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.25);
  pointer-events: none;
}
.score-tooltip-portal .score-tip-title {
  font-weight: 700;
  font-size: 13px;
  margin-bottom: 6px;
}
.score-tooltip-portal .score-tip-desc {
  font-size: 12px;
  line-height: 1.55;
  color: #d1d5db;
}
</style>
